import { useState, useEffect } from "react";
import {
  Avatar,
  Button,
  TextField,
  Alert,
  Paper,
  Container,
  Typography,
  InputAdornment,
  Box
} from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import axiosInstance from "../../axiosInstance";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import {
  getSubdomainPrefix,
  isRootDomain,
  buildTenantLoginUrl,
  getRootDomain,
} from "../../utils/subdomain";

function LoginPage() {
  const [mobile, setMobile] = useState("");
  const [password, setPassword] = useState("");
  const [prefix, setPrefix] = useState("");
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false)
  const [hostInfo, setHostInfo] = useState({
    rootDomain: "",
    subdomain: null,
    isRoot: true,
  });

  const navigate = useNavigate();
  const { login } = useAuth(); // <-- AuthContext login()

  useEffect(() => {
    const user = localStorage.getItem("user");
    const token = localStorage.getItem("authToken");
    if (user && token) {
      navigate("/list");
    }
  }, [navigate]);

  useEffect(() => {
    const host = window.location.hostname;
    const subdomain = getSubdomainPrefix(host);
    const rootDomain = getRootDomain(host);
    setHostInfo({
      rootDomain,
      subdomain,
      isRoot: isRootDomain(host),
    });
    if (subdomain) {
      setPrefix(subdomain);
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    // If on root domain and user entered a prefix, redirect to that subdomain
    if (hostInfo.isRoot && prefix.trim()) {
      const tenantUrl = buildTenantLoginUrl(prefix.trim(), window.location.hostname);
      if (tenantUrl) {
        window.location.href = tenantUrl;
        return;
      }
    }

    // If on root domain and NO prefix entered, show error
    // Only Super Admin can login from root domain without prefix
    // if (hostInfo.isRoot && !prefix.trim()) {
    //   setError("Invaid subdomain.");
    //   return;
    // }

    try {
      const res = await axiosInstance.post("/auth/login", {
        mobile,
        password,
        tenantHost: window.location.hostname,
      });

      if (!res.data?.user || !res.data?.token) {
        setError("Invalid response from server");
        return;
      }

      // Save token
      localStorage.setItem("authToken", res.data.token);

      const mappedUser = {
        name: res.data.user.fullName,  
        userId: res.data.user.userId,
        roleId: res.data.user.roleId,
        passwordUpdated: res?.data?.user?.passwordUpdated,
        internalAdmin: res?.data?.user?.internalAdmin,
        employerId: res?.data?.user?.employerId ? res.data.user.employerId : '',
        employerName: res?.data?.user?.employerName ? res.data.user.employerName : '',
        prefix: res?.data?.user?.prefix ? res.data.user.prefix : '',
        _id: res?.data?.user?._id
      };

      // Save to localStorage
      localStorage.setItem("user", JSON.stringify(mappedUser));

      login(mappedUser);

      // Redirect
      navigate("/list");

    } catch (err) {
      setError(err.response?.data?.message || "Login failed");
    }
  };

  return (
    <Container component="main" maxWidth="xs">
      <Paper
        elevation={6}
        sx={{
          mt: 8,
          p: 4,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          borderRadius: 3,
        }}
      >
        <Avatar sx={{ m: 1, bgcolor: "primary.main" }}>
          <LockOutlinedIcon />
        </Avatar>

        <Typography component="h1" variant="h5">
          Sign In
        </Typography>

        {error && (
          <Alert severity="error" sx={{ width: "100%", mt: 2 }}>
            {error}
          </Alert>
        )}

        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1, width: "100%" }}>
          <TextField
            label="Mobile Number"
            name="mobile"
            fullWidth
            required
            value={mobile}
            onChange={e=>setMobile(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">🇮🇳 +91</InputAdornment>
              ),
              inputMode: "numeric"
            }}
             inputProps={{
              minLength: 10,
              maxLength: 10,
              pattern: "[0-9]{10}",
            }}
          />

          <TextField
            margin="normal"
            required
            fullWidth
            label="Password"
            type={showPassword ? "text" : "password"}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end" sx={{cursor: "pointer"}}>
                  {
                    !showPassword ? <VisibilityIcon onClick={()=>setShowPassword(true)} /> : <VisibilityOffIcon onClick={()=>setShowPassword(false)} />
                  }
                </InputAdornment>
              ),
            }}
          />

          <Button
            type="submit"
            fullWidth
            variant="contained"
            size="large"
            sx={{ mt: 3, mb: 2 }}
          >
            Sign In
          </Button>
        </Box>
      </Paper>
    </Container>
  );
}

export default LoginPage;
